module.exports = __webpack_public_path__ + "static/forecast/fresh-snow/knee-5a8d7f294fb425a37dbf44d1242f3e0f.svg";